import { render, staticRenderFns } from "./SystemNotifications.vue?vue&type=template&id=aeb6bb9c&scoped=true&"
import script from "./SystemNotifications.vue?vue&type=script&lang=js&"
export * from "./SystemNotifications.vue?vue&type=script&lang=js&"
import style0 from "./SystemNotifications.vue?vue&type=style&index=0&id=aeb6bb9c&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aeb6bb9c",
  null
  
)

export default component.exports